var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 108,
    viewBox: "0 0 185 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.065 4.48414L184.111 2.43885L182.065 0.393555L180.02 2.43885L182.065 4.48414Z",
    fill: "#0033CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.065 30.1952L184.111 28.1499L182.065 26.1046L180.02 28.1499L182.065 30.1952Z",
    fill: "#0033CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.065 55.9059L184.111 53.8606L182.065 51.8154L180.02 53.8606L182.065 55.9059Z",
    fill: "#0033CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.065 81.617L184.111 79.5717L182.065 77.5264L180.02 79.5717L182.065 81.617Z",
    fill: "#0033CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.065 107.328L184.111 105.283L182.065 103.237L180.02 105.283L182.065 107.328Z",
    fill: "#0033CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.348 4.48414L158.394 2.43885L156.348 0.393553L154.302 2.43885L156.348 4.48414Z",
    fill: "#0033CC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.348 30.1952L158.394 28.1499L156.348 26.1046L154.302 28.1499L156.348 30.1952Z",
    fill: "#0033CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.348 55.9059L158.394 53.8606L156.348 51.8154L154.302 53.8606L156.348 55.9059Z",
    fill: "#0033CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.348 81.617L158.394 79.5717L156.348 77.5264L154.302 79.5717L156.348 81.617Z",
    fill: "#0033CC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M156.348 107.328L158.394 105.283L156.348 103.237L154.302 105.283L156.348 107.328Z",
    fill: "#0033CC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M130.631 4.48414L132.677 2.43884L130.631 0.393552L128.585 2.43884L130.631 4.48414Z",
    fill: "#0033CC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.631 30.1952L132.677 28.1499L130.631 26.1046L128.585 28.1499L130.631 30.1952Z",
    fill: "#0033CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.631 55.9059L132.677 53.8606L130.631 51.8154L128.585 53.8606L130.631 55.9059Z",
    fill: "#0033CC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.631 81.617L132.677 79.5717L130.631 77.5264L128.585 79.5717L130.631 81.617Z",
    fill: "#0033CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.631 107.328L132.677 105.283L130.631 103.237L128.585 105.283L130.631 107.328Z",
    fill: "#0033CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.914 4.48414L106.96 2.43884L104.914 0.393551L102.868 2.43884L104.914 4.48414Z",
    fill: "#0033CC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.914 30.1952L106.96 28.1499L104.914 26.1046L102.868 28.1499L104.914 30.1952Z",
    fill: "#0033CC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.914 55.9059L106.96 53.8606L104.914 51.8153L102.868 53.8606L104.914 55.9059Z",
    fill: "#0033CC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.914 81.617L106.96 79.5717L104.914 77.5264L102.868 79.5717L104.914 81.617Z",
    fill: "#0033CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.914 107.328L106.96 105.283L104.914 103.237L102.868 105.283L104.914 107.328Z",
    fill: "#0033CC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1968 4.48413L81.2426 2.43884L79.1968 0.39355L77.1511 2.43884L79.1968 4.48413Z",
    fill: "#0033CC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1968 30.1952L81.2426 28.1499L79.1968 26.1046L77.1511 28.1499L79.1968 30.1952Z",
    fill: "#0033CC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1968 55.9059L81.2426 53.8606L79.1968 51.8153L77.1511 53.8606L79.1968 55.9059Z",
    fill: "#0033CC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1968 81.617L81.2426 79.5717L79.1968 77.5264L77.1511 79.5717L79.1968 81.617Z",
    fill: "#0033CC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1968 107.328L81.2426 105.283L79.1968 103.237L77.1511 105.283L79.1968 107.328Z",
    fill: "#0033CC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4796 4.48413L55.5254 2.43884L53.4796 0.393549L51.4339 2.43884L53.4796 4.48413Z",
    fill: "#0033CC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4796 30.1952L55.5254 28.1499L53.4796 26.1046L51.4339 28.1499L53.4796 30.1952Z",
    fill: "#0033CC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4796 55.9059L55.5254 53.8606L53.4796 51.8153L51.4339 53.8606L53.4796 55.9059Z",
    fill: "#0033CC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4796 81.617L55.5254 79.5717L53.4796 77.5264L51.4338 79.5717L53.4796 81.617Z",
    fill: "#0033CC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4796 107.328L55.5254 105.283L53.4796 103.237L51.4338 105.283L53.4796 107.328Z",
    fill: "#0033CC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7624 4.48413L29.8082 2.43884L27.7624 0.393548L25.7166 2.43884L27.7624 4.48413Z",
    fill: "#0033CC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7624 30.1952L29.8082 28.1499L27.7624 26.1046L25.7166 28.1499L27.7624 30.1952Z",
    fill: "#0033CC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7624 55.9059L29.8082 53.8606L27.7624 51.8153L25.7166 53.8606L27.7624 55.9059Z",
    fill: "#0033CC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7624 81.617L29.8082 79.5717L27.7624 77.5264L25.7166 79.5717L27.7624 81.617Z",
    fill: "#0033CC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7624 107.328L29.8082 105.283L27.7624 103.237L25.7166 105.283L27.7624 107.328Z",
    fill: "#0033CC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04579 4.48413L4.09157 2.43884L2.04579 0.393547L-8.94026e-08 2.43884L2.04579 4.48413Z",
    fill: "#0033CC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04579 30.1952L4.09157 28.1499L2.04579 26.1046L-1.21327e-06 28.1499L2.04579 30.1952Z",
    fill: "#0033CC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04579 55.9059L4.09157 53.8606L2.04579 51.8153L-2.33712e-06 53.8606L2.04579 55.9059Z",
    fill: "#0033CC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04579 81.617L4.09156 79.5717L2.04579 77.5264L-3.46099e-06 79.5717L2.04579 81.617Z",
    fill: "#0033CC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04579 107.328L4.09156 105.283L2.04579 103.237L-4.58485e-06 105.283L2.04579 107.328Z",
    fill: "#0033CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.7f42bfb710e665bafc5e01c6e555300e.svg";
export { ForwardRef as ReactComponent };